"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.selectValueByWalk = void 0;

var _reReselect = _interopRequireDefault(require("re-reselect"));

var _selectEntityByActivityIdentifier = _interopRequireDefault(require("./selectEntityByActivityIdentifier"));

var _selectEntityByKeyAndId = _interopRequireDefault(require("./selectEntityByKeyAndId"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // import selectEntityByKeyAndNormalizer from './selectEntityByKeyAndNormalizer'


var mapArgsToCacheKey = function mapArgsToCacheKey(state, walk) {
  return "".concat(walk.topActivityIdentifier || '').concat(walk.topKey || '').concat(walk.topId || '').concat(walk.path || '');
};

var entityFrom = function entityFrom(data, entity, key //config={}
) {
  // const { parentKey } = config
  var normalizer = entity[key];
  var stateKey = (normalizer || {}).type === '__normalizer__' && (normalizer || {}).stateKey;
  if (!stateKey) return;
  var childEntity;
  var idKey = "".concat(key, "Id");
  var id = entity[idKey];

  if (id) {
    childEntity = (0, _selectEntityByKeyAndId["default"])({
      data: data
    }, stateKey, id);
  }

  if (!childEntity) {
    var activityIdentifierKey = "".concat(key, "ActivityIdentifier");
    var activityIdentifier = entity[activityIdentifierKey];

    if (activityIdentifier) {
      childEntity = (0, _selectEntityByActivityIdentifier["default"])({
        data: data
      }, activityIdentifier);
    }
  }

  if (!childEntity) {
    /*TODO*/
    //childEntity = selectEntityByKeyAndNormalizer({ data },
    //                                             stateKey,
    //                                             { datumKey: key, stateKey: parentKey })
  }

  return childEntity;
};

var valueFrom = function valueFrom(data, entity, path) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (path.includes('.')) {
    var chunks = path.split('.');
    var key = chunks[0];
    var childEntity = entityFrom(data, entity, key, config);

    if (childEntity) {
      return valueFrom(data, childEntity, chunks.slice(1).join('.'), {
        parentKey: childEntity.__parent__
      });
    }
  }

  var value = entity[path];

  if (typeof value === 'undefined' || value && value.type === '__normalizer__') {
    value = entityFrom(data, entity, path);
  }

  return value;
};

var selectValueByWalk = (0, _reReselect["default"])(function (state) {
  return state.data;
}, function (state, walk) {
  return walk.topActivityIdentifier;
}, function (state, walk) {
  return walk.topKey;
}, function (state, walk) {
  return walk.topId;
}, function (state, walk) {
  return walk.path;
}, function (data, topActivityIdentifier, topKey, topId, path) {
  var entity = topActivityIdentifier ? (0, _selectEntityByActivityIdentifier["default"])({
    data: data
  }, topActivityIdentifier) : (0, _selectEntityByKeyAndId["default"])({
    data: data
  }, topKey, topId);

  if (entity) {
    return valueFrom(data, entity, path, {
      parentKey: topKey
    });
  }
})(mapArgsToCacheKey);
exports.selectValueByWalk = selectValueByWalk;
var _default = selectValueByWalk;
exports["default"] = _default;